import { PageHeader } from '@/components/PageHeader';
import { QueryState } from '@/components/QueryState';
import { shortDate } from '@/lib/format';
import { useMembers } from '@/lib/queries';

/**
 * 우리 담당자.
 *
 * <p><b>초대는 본사가 한다</b>(사용자 결정 2026-09-10 · DOC-84 §7 ④). 협력사 계정은 본사 직원이
 * 마스터 화면에서 열고, 초대받은 사람이 링크로 비밀번호를 정하면 계정이 선다(DOC-82 §3-1). 그래서
 * 이 화면에는 초대 버튼이 없다 — 협력사가 협력사를 부르면 계정이 회사의 통제 밖에서 늘어난다.
 * 초대 중인 사람은 「초대 n월 n일」 배지로 여기 보인다.
 *
 * <p>해제는 <b>지움이 아니라 끔</b>이다 — 그 사람이 올린 검측 요청의 작성자를 잃지 않기 위해서다.
 */
export function MembersPage() {
  const members = useMembers();
  const rows = members.data ?? [];

  return (
    <>
      <PageHeader title="담당자" back={false} />
      <QueryState
        pending={members.isPending}
        error={members.isError}
        empty={rows.length === 0}
        emptyText="등록된 담당자가 없습니다."
      >
        <ul className="flex flex-col gap-2">
          {rows.map((row) => (
            <li key={row.id} className="card flex items-center justify-between gap-3">
              <div className="min-w-0">
                <div className="truncate text-ui-md">{row.name}</div>
                <div className="truncate text-ui-2xs" style={{ color: 'var(--text-muted)' }}>
                  {row.email}
                  {row.phone !== null && ` · ${row.phone}`}
                </div>
              </div>
              {row.acceptedAt === null ? (
                <span className="badge badge-blue shrink-0">초대 {shortDate(row.invitedAt)}</span>
              ) : (
                !row.active && <span className="badge badge-gray shrink-0">해제됨</span>
              )}
            </li>
          ))}
        </ul>
      </QueryState>
    </>
  );
}
